import { AfterViewInit, Component, EventEmitter, input, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IconsService } from '../shared/services/icons.service';
import { ImageService } from '../shared/services/image.service';
import { SettlementsService } from '../services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { ModalGasMeterComponent } from 'src/app/components/modals/modal-gas-meter.component';
import { ModalGasMeterMaintenanceComponent } from 'src/app/components/modals/modal-gas-meter-maintenance.component';
import { ModalGasMeterMaintenanceRemoveComponent } from 'src/app/components/modals/modal-gas-meter-maintenance-remove.component';
import { GasMeter } from '../models/gas-meter.model';
import { GasMeterBrand, GasMeterType, GasMeterTypeBrandRelation } from '../models/gas-meter-catalog.interface';
import { forkJoin } from 'rxjs';

@Component({
  selector: '[app-meter-unit]',
  template: `
    <div class="d-flex">
      <div>
        <h5 class="mb-4 mt-1"><span class="float-start mt-1">MEDIDORES</span></h5>
      </div>
      <div class="ms-auto">
        <button class="btn btn-outline-secondary btn-sm" (click)="addMedidor()">
          <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
          Agregar medidor
        </button>
      </div>
    </div>
    <div class="row mt-3 px-2">
      <div class="col-12 mb-1 bg-light p-2"  *ngFor="let medidor of medidores()">
        <div class="d-flex">
          <div class="border border-2" style="width: 140px;">
            <img [src]="last_meter" width="100%">
          </div>
          <div class="ms-2 flex-fill pe-2">
            <h5 class="mb-0">{{medidor.name}}</h5>
            <h3 class="mb-0">{{getMeterHeaderLabel(medidor)}}</h3>
            <p class="text-muted text-sm mt-2 mb-0">Última lectura:</p>
            <p class="mb-0">{{medidor.last_read | meterReadFormat:getReadingFormat(medidor)}}</p>
          </div>
          <div class="ms-auto text-end">
            <div class="badge badge-pill border border-2 border-success bg-transparent text-success rounded-5 float-end px-3" *ngIf="!medidor.maintenance&&medidor.meter_status==='ACTIVO'">{{medidor.meter_status}}</div>
            <div class="badge badge-pill border border-2 border-warning bg-transparent text-warning rounded-5 float-end px-3" *ngIf="!medidor.maintenance&&medidor.meter_status==='INACTIVO'">{{medidor.meter_status}}</div>
            <div class="badge badge-pill bg-warning rounded-5 float-end px-3" *ngIf="medidor.maintenance">En mantenimiento</div>

            <br><!-- button type="button" class="btn btn-outline-secondary btn-sm mb-2" >Historial</!-->
            <button type="button" class="btn btn-outline-secondary ms-2 btn-sm mb-2 mt-2" (click)="editMedidor(medidor)">
              <fa-icon [icon]="icons.faEdit" class="me-2"></fa-icon>
              Editar
            </button><br>
            <button type="button" class="btn btn-outline-warning ms-2 btn-sm mb-2" *ngIf="!medidor.maintenance" (click)="addMaintenance(medidor)">
              <fa-icon [icon]="icons.faHammer" class="ms-2"></fa-icon>
              Mant.
            </button><br>
            <button type="button" class="btn btn-outline-danger ms-2 btn-sm" *ngIf="medidor.maintenance" (click)="removeMaintenance(medidor)">
              <fa-icon [icon]="icons.faHammer" class="ms-2"></fa-icon>
              Mant.
            </button>
            <button 
                type="button" 
                class="btn btn-outline-info btn-sm mt-2 w-100"
                data-bs-toggle="offcanvas" 
                data-bs-target="#auditTrailOffcanvas"
                (click)="loadAuditTrail(medidor)"
              >
                <fa-icon [icon]="icons.faHistory" class="me-1"></fa-icon>
                Historial
              </button>
          </div>
        </div>
      </div>
      <div class="list-group-item" *ngIf="medidores().length==0">
        <div class="my-3 text-center">
          <h5>La unidad no tiene medidor asignado.</h5>
          <!-- button type="button" class="btn btn-lg btn-primary rounded-5" >
            <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>Agregar medidor
          </button -->
        </div>
        <app-modal-gas-meter [unit]="unit"></app-modal-gas-meter>
      </div>
    </div>
    <app-modal-gas-meter [unit]="unit" [meter]="selectedMedidor" (updateGMeter)="updateGasMeter($event)" (updateDismiss)="updateDismissed()"></app-modal-gas-meter>
    <app-modal-gas-meter-maintenance [meter]="selectedMedidor" (updateDismiss)="updateDismissed()"></app-modal-gas-meter-maintenance>
    <app-modal-gas-meter-maintenance-remove [meter]="selectedMedidor" (updateDismiss)="updateDismissed()"></app-modal-gas-meter-maintenance-remove>
    
    <app-audit-trail-offcanvas
      [auditData]="auditTrailData"
      [loading]="auditTrailLoading"
      objectType="gas_meter"
      [customRenderer]="true"
    ></app-audit-trail-offcanvas>
  `,
  styles: []
})
export class MeterUnitComponent implements OnInit, AfterViewInit {
  medidores = input<GasMeter[]>([]);
  @Input() unit: any;
  @Input() permissions: any;
  @Output() updateData = new EventEmitter<boolean>();

  @ViewChild(ModalGasMeterComponent, { static: true }) modalGasMeterComponent !: ModalGasMeterComponent;
  @ViewChild(ModalGasMeterMaintenanceComponent, { static: true }) modalGasMeterMaintenance !: ModalGasMeterMaintenanceComponent;
  @ViewChild(ModalGasMeterMaintenanceRemoveComponent, { static: true }) modalGasMeterMaintenanceRemove !: ModalGasMeterMaintenanceRemoveComponent;

  last_meter: any;
  addingMedidor: boolean = false;

  selectedMedidor: any;
  private readingFormatByTypeId = new Map<number, string>();
  private readingFormatByTypeKey = new Map<string, string>();
  private readingFormatByTypeBrandRelationId = new Map<number, string>();
  private typeLabelById = new Map<number, string>();
  private brandLabelById = new Map<number, string>();
  private typeLabelByTypeBrandRelationId = new Map<number, string>();
  private brandLabelByTypeBrandRelationId = new Map<number, string>();

  // Audit Trail properties
  auditTrailData: any = null;
  auditTrailLoading: boolean = false;
  selectedMeterForAudit: any = null;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    private images: ImageService
  ) { }

  ngOnInit(): void {
    this.loadGasMeterCatalogData();
  }

  ngAfterViewInit(): void {
    // this.loadBillLatest(this.unit);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['unit'] && changes['unit'].currentValue) {
      console.log('ngOnChanges', changes['unit'].currentValue);
      this.loadBillLatest(changes['unit'].currentValue);
    }
  }

  loadBillLatest(unit: any) {
    console.log('loadBillLatest', unit);
    this.store.getBillLatest(unit.id).subscribe({
      next: (data: any) => {
        if (data != null && data.medidor != null) {
          this.last_meter = this.images.buildURL(data.medidor);
        }
      },
      error: () => {
        console.log('loadBillLatest failed', unit);
      }
    });
  }

  getReadingFormat(medidor: any): string {
    const typeId = this.toNumber(medidor?.gas_meter_type_id ?? medidor?.meter_type_id ?? medidor?.meter_type);
    if (typeId !== null && this.readingFormatByTypeId.has(typeId)) {
      return this.readingFormatByTypeId.get(typeId) ?? '';
    }

    const relationId = this.toNumber(medidor?.gas_meter_type_brand_id);
    if (relationId !== null && this.readingFormatByTypeBrandRelationId.has(relationId)) {
      return this.readingFormatByTypeBrandRelationId.get(relationId) ?? '';
    }

    const typeKey = this.normalizeCatalogKey(medidor?.meter_type);
    if (typeKey && this.readingFormatByTypeKey.has(typeKey)) {
      return this.readingFormatByTypeKey.get(typeKey) ?? '';
    }

    return '';
  }

  getMeterHeaderLabel(medidor: any): string {
    const relationId = this.toNumber(medidor?.gas_meter_type_brand_id);

    const brandLabel = this.resolveBrandLabel(medidor, relationId);
    const typeLabel = this.resolveTypeLabel(medidor, relationId);

    return [brandLabel, typeLabel].filter((value) => !!value).join(' ').trim();
  }

  addMaintenance(medidor: any) {
    this.selectedMedidor = medidor;
    const modalTemplate: any | undefined = this.modalGasMeterMaintenance;
    if (modalTemplate) {
      this.modalGasMeterMaintenance.openModal(modalTemplate['modalGasMeterMaintenance']);
    }
  }

  removeMaintenance(medidor: any) {
    this.selectedMedidor = medidor;
    // new bs.Modal(<HTMLInputElement>document.getElementById('modalGasMeterMaintenanceRemove')).show();
    const modalTemplate: any | undefined = this.modalGasMeterMaintenanceRemove;
    if (modalTemplate) {
      this.modalGasMeterMaintenanceRemove.openModal(modalTemplate['modalGasMeterMaintenanceRemove']);
    }
  }

  editMedidor(medidor: any) {
    this.selectedMedidor = medidor;
    const modalTemplate: any | undefined = this.modalGasMeterComponent;
    if (modalTemplate) {
      this.modalGasMeterComponent.openModal(modalTemplate['modalGasMeter']);
    }
  }

  addMedidor() {
    const modalTemplate: any | undefined = this.modalGasMeterComponent;
    if (modalTemplate) {
      this.modalGasMeterComponent.openModal(modalTemplate['modalGasMeter']);
    }
  }

  updateGasMeter(data: any) {
    // this.loadUnit(this.unit.id);
    this.updateData.emit(true);
  }

  updateDismissed() {
    this.selectedMedidor = null;
    this.updateData.emit(true);
  }

  loadAuditTrail(meter: any): void {
    if (!meter?.id) {
      this.toastr.error('No se puede cargar el historial sin un ID de medidor válido', 'Error');
      return;
    }

    this.selectedMeterForAudit = meter;
    this.auditTrailLoading = true;
    this.auditTrailData = null;

    this.store.getGasMeterAuditTrail(meter.id).subscribe({
      next: (data: any) => {
        console.log('Gas meter audit trail data:', data);
        this.auditTrailData = data;
        this.auditTrailLoading = false;
      },
      error: (err: any) => {
        console.error('Error loading gas meter audit trail:', err);
        this.toastr.error('Error al cargar el historial de cambios del medidor', 'Error');
        this.auditTrailLoading = false;
      }
    });
  }

  private loadGasMeterCatalogData(): void {
    forkJoin({
      types: this.store.getGasMeterTypes(),
      brands: this.store.getGasMeterBrands(),
      relations: this.store.getGasMeterTypeBrands()
    }).subscribe({
      next: (result) => {
        this.populateTypeMaps(result.types || []);
        this.populateBrandMaps(result.brands || []);
        this.populateRelationMaps(result.relations || []);
      },
      error: () => {
        // Keep UI functional even if catalog lookup fails.
        this.readingFormatByTypeId.clear();
        this.readingFormatByTypeKey.clear();
        this.readingFormatByTypeBrandRelationId.clear();
        this.typeLabelById.clear();
        this.brandLabelById.clear();
        this.typeLabelByTypeBrandRelationId.clear();
        this.brandLabelByTypeBrandRelationId.clear();
      }
    });
  }

  private populateTypeMaps(types: GasMeterType[]): void {
    this.readingFormatByTypeId.clear();
    this.readingFormatByTypeKey.clear();
    this.typeLabelById.clear();

    (types || []).forEach((type) => {
      const readingFormat = type?.reading_format ?? '';
      const typeId = this.toNumber(type?.id);
      const label = `${type?.description ?? ''}`.trim() || `${type?.name ?? ''}`.trim();

      if (typeId !== null) {
        if (readingFormat) {
          this.readingFormatByTypeId.set(typeId, readingFormat);
        }
        if (label) {
          this.typeLabelById.set(typeId, label);
        }
      }

      [type?.name, type?.description].forEach((value) => {
        const key = this.normalizeCatalogKey(value);
        if (key && readingFormat) {
          this.readingFormatByTypeKey.set(key, readingFormat);
        }
      });
    });
  }

  private populateBrandMaps(brands: GasMeterBrand[]): void {
    this.brandLabelById.clear();

    (brands || []).forEach((brand) => {
      const brandId = this.toNumber(brand?.id);
      const label = `${brand?.description ?? ''}`.trim() || `${brand?.name ?? ''}`.trim();

      if (brandId !== null && label) {
        this.brandLabelById.set(brandId, label);
      }
    });
  }

  private populateRelationMaps(relations: GasMeterTypeBrandRelation[]): void {
    this.readingFormatByTypeBrandRelationId.clear();
    this.typeLabelByTypeBrandRelationId.clear();
    this.brandLabelByTypeBrandRelationId.clear();

    (relations || []).forEach((relation) => {
      const relationId = this.toNumber(relation?.id);
      if (relationId === null) {
        return;
      }

      const readingFormat = relation?.gas_meter_type_id?.reading_format ?? '';
      const typeLabel = `${relation?.gas_meter_type_id?.description ?? ''}`.trim() || `${relation?.gas_meter_type_id?.name ?? ''}`.trim();
      const brandLabel = `${relation?.gas_meter_brand_id?.description ?? ''}`.trim() || `${relation?.gas_meter_brand_id?.name ?? ''}`.trim();

      if (readingFormat) {
        this.readingFormatByTypeBrandRelationId.set(relationId, readingFormat);
      }
      if (typeLabel) {
        this.typeLabelByTypeBrandRelationId.set(relationId, typeLabel);
      }
      if (brandLabel) {
        this.brandLabelByTypeBrandRelationId.set(relationId, brandLabel);
      }
    });
  }

  private resolveTypeLabel(medidor: any, relationId: number | null): string {
    const typeId = this.toNumber(medidor?.gas_meter_type_id ?? medidor?.meter_type_id ?? medidor?.meter_type);
    if (typeId !== null && this.typeLabelById.has(typeId)) {
      return this.typeLabelById.get(typeId) ?? '';
    }

    if (relationId !== null && this.typeLabelByTypeBrandRelationId.has(relationId)) {
      return this.typeLabelByTypeBrandRelationId.get(relationId) ?? '';
    }

    const typeValue = `${medidor?.meter_type ?? ''}`.trim();
    return typeValue;
  }

  private resolveBrandLabel(medidor: any, relationId: number | null): string {
    const brandId = this.toNumber(medidor?.gas_meter_brand_id ?? medidor?.meter_brand_id ?? medidor?.meter_brand);
    if (brandId !== null && this.brandLabelById.has(brandId)) {
      return this.brandLabelById.get(brandId) ?? '';
    }

    if (relationId !== null && this.brandLabelByTypeBrandRelationId.has(relationId)) {
      return this.brandLabelByTypeBrandRelationId.get(relationId) ?? '';
    }

    const brandValue = `${medidor?.meter_brand ?? ''}`.trim();
    return brandValue;
  }

  private normalizeCatalogKey(value: any): string {
    return `${value ?? ''}`.trim().toLowerCase().replace(/[\s_-]+/g, '');
  }

  private toNumber(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
}
